import { chatGptT } from "../../type";

export const chatGptList: chatGptT[] = [
  {
    type: "상황/장소",
    key: "situation",
    question: [
      "당신의 음악 여행이 시작되려면 어디에서 출발할 건가요? 🌍",
      "만약 당신의 일상이 블록버스터 영화라면, 어떤 장면에서 음악이 흘러나올까요? 🎬",
      "당신의 인생 스테이지에 무대 메이크업을 해야 한다면, 어떤 노래가 피팅 할까요? 💄🎤",
      "만약 당신이 시간을 되돌릴 수 있다면, 어떤 노래가 그 순간의 멜로디가 되었으면 좋겠나요? ⏳🎶",
      "만약 당신의 일상을 만화로 그린다면, 어떤 장면에 어떤 음악을 더해주고 싶으세요?",
      "오늘은 뭐하고 시간을 보내실 건가요? 음악과 함께 라면 더 재미있겠죠?",
      "당신의 마음이 혹시 작은 모험을 갈망하고 있다면, 그 모험의 배경은 어떤 상황인가요?",
      "당신이 지금 음악을 들으며 춤을 추게 된다면, 어떤 상황에서 춤과 노래가 당신의 리듬을 따라갈까요?",
      "혹시 지금 뭐든지 하는 동안 음악을 틀어 놓으려고 하고 계신가요? 그렇다면 어떤 상황이신가요?",
      "당신의 기분을 좋게 만드는 노래 한 곡을 상상해보세요. 그 노래가 흘러나오는 상황도 함께 말씀해주세요.",
    ],
    none: {
      tag: "없어요🤔",
      bg: "asdf",
      ment: [
        "어떤 분위기가 어울릴지 고민 중이신가요? 고민이 내 안의 음악 가치관을 성장시켜줘요.",
        "상황을 선택하지 않은 당신, 음악의 속도감 있는 선택을 기다리고 있군요!",
        "어떤 선택이든 추천 음악이 너의 감정을 노래할 거에요.",
        "음악은 어떤 선택이든 당신의 감정을 표현할 준비가 되어있어요.",
        "상황을 선택하지 않아도, 음악의 박자가 심장 박동과 어우러질거에요.",
      ],
      idx: -1,
    },
    tagList: [
      {
        tag: "드라이브/여행🚗",
        bg: "https://images.unsplash.com/photo-1533408874882-397bf377a8c2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        ment: [
          "엔진 소리와 함께 나만의 뮤직 비디오가 시작될 준비가 되셨나요?",
          "바퀴가 도는 대로 음악의 멋진 풍경을 만나는 중!🚙🎧",
          "스릴 넘치는 고속도로에서 마치 내가 영화 주인공이 된 기분으로!",
          "차 안에서 흥얼거리는 당신, 당신은 스타입니다! ⭐🎤",
          "누구든지 무대 위의 슈퍼스타로 느껴지는 순간들을 만들어봐요!",
        ],
        idx: 8290,
      },
      {
        tag: "회사🏢",
        bg: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        ment: [
          "이제는 업무 보고서말고 음악 리포트를 작성해보는 건 어떨까요?",
          "회사에서도 미니 음악 페스티벌을 개최하는 건 어떨까요?",
          "커피 대신 음악으로 업무 활력을 얻어보는 건 어떨까요?",
          "업무 속에서 음악으로 리듬을 찾아보세요~",
          "회사 생활도 음악과 같다면, 동료들은 함께 연주하는 멋진 밴드!",
          "바쁜 업무 속에서도 음악을 빼놓지 말고 모두 함께 춤을 춰보세요!",
        ],
        idx: 188,
      },
      {
        tag: "산⛰️",
        bg: "https://images.unsplash.com/photo-1572938970395-80cf7a7be09f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
        ment: [
          "산 위로 오른 느낌으로 떠날 수 있는 마법의 음악 여행을 떠나볼까요?",
          "산 꼭대기에서 음악을 들으면 바람이 몸을 흔들어주는 기분이 들 수도 있어요!",
          "노래를 들으면 마치 산세에 울려퍼지는 음악회가 열린 것 같은 기분이 들어요?",
          "산 꼭대기에서 음악을 들으면 하늘과 대화하는 듯한 순간을 느낄 수 있어요!",
          '"산" 선택! 음악과 함께라면 어디든 산으로 가는 거에요.',
          "마치 자연과 하나가 되어 노래하는 기분을 느낄 수 있을 것 같아요.",
        ],
        idx: 7034,
      },
      {
        tag: "바다🌊",
        bg: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80",
        ment: [
          "음악을 틀면 마치 고래가 노래하는 콘서트에 참석한 것 같은 기분!",
          "바닷바람과 함께 물결이 리듬을 타고 춤을 추는 듯한 멋진 순간을!",
          "해파리 밴드가 신나게 춤을 추는 모습이 떠오르는 것 같아요!",
          "음악과 함께라면 바다도 노래하는 듯한 환상적인 장면으로 변할거에요!",
          "음악을 들으면 내 마음도 파도처럼 밀려오는 기분을 느낄 수 있어요.",
          "모래가 나만을 위한 무대가 된다는 느낌을 받을거에요! ",
        ],
        idx: 56,
      },
      {
        tag: "독서/공부📚",
        bg: "https://images.unsplash.com/photo-1572061487787-3cd4292f12bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "지식의 바다에서 고요한 음악회가 열리는 듯한 경험을 느낄 수 있어요!",
          "책을 펼치면 내 머릿속에서 음악을 기분 좋게 느끼는 것 같아요!",
          "지식의 세계로 들어가면 책장이 음악의 악보가 되어줄거에요!",
          "음악을 틀면 단어들이 노래가 되어 글자가 화음을 이룰거에요.",
          "음악과 함께 공부하면 마치 단어들이 리듬에 맞춰 춤을 출거에요.",
          "음악과 함께 공부하면 새로운 아이디어가 멋진 소나타로 펼쳐질 것 같아요!",
        ],
        idx: 8291,
      },
      {
        tag: "학교🏫",
        bg: "https://images.unsplash.com/photo-1613896527026-f195d5c818ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "음악과 함께라면 강의실이 음악 스튜디오가 되는 듯한 기분이 들어요!",
          "학교에서 음악을 틀고 교과서가 노래를 부르고 있는 듯한 장면을 상상해보세요!",
          "음악과 함께라면 교실이 흥겨운 뮤직 페스티벌 무대로!",
          "학교 생활에 음악을 더하면, 수업이 라이브 공연으로 바뀌는 기분을 느낄 수 있어요!",
          "음악을 틀고 모든 학습이 멋진 음악회로 전환되는 듯한 환상적인 상상을 해보세요!",
          "음악을 틀면공부가 노래 가운데에 숨어있는 것처럼 느껴질 수 있어요!",
        ],
        idx: 174,
      },
      {
        tag: "집🏠",
        bg: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80",
        ment: [
          "음악을 틀면 내 방이 흥겹게 춤을 추며, 음악과 함께하는 듯한 기분이 들 수도 있어요!",
          "소파가 리듬을 전달하고 쿠션들이 함께 흔들리는 것 같은 기분일거에요!",
          "음악과 함께라면 내가 집 안 거실에서의 슈퍼스타라는 느낌!",
          "음악을 틀면 내가 음악과 함께 집을 흔들어주는 듯한 기분이 들 수 있어요!",
          "마치 방 안이 나만의 뮤직 스튜디오로 변신하여, 내가 노래를 만들어내는 느낌을!",
          '"집" 선택! 내가 DJ이자 춤꾼으로 변신한 것 같은 느낌을 받을 수 있어요!',
        ],
        idx: 143,
      },
      {
        tag: "등교/출근길🚶",
        bg: "https://plus.unsplash.com/premium_photo-1661774796613-e744c2dc0467?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80",
        ment: [
          '"등교/출근길" 선택! 나만의 뮤직 비디오가 펼쳐지는 것 같을 거에요!',
          "음악을 틀고 사람들이 노래와 함께 춤을 추며 행진하는 멋진 모습을 상상해보세요!",
          "거리가 노래에 맞춰 걷는 것처럼 느껴져서, 음악의 주인공이 된 듯한 기분일 거에요!",
          "지나가는 사람들도 이 음악과 함께 춤을 추는 것 같은 환상적인 상상을 해보세요!",
          "등교/출근길에 음악을 듣는다면, 길 곳곳에서 음악에 맞춰 무대가 펼쳐져요.",
          "모두 함께 음악을 즐기며 춤을 추는 듯한 기분을 느낄 수 있을 거에요!",
        ],
        idx: 8292,
      },
      {
        tag: "하교/퇴근길🚶‍♂️",
        bg: "https://images.unsplash.com/photo-1489410342162-b4b300a0bb15?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "퇴근길에 음악을 듣는다면, 각각의 곡이 다양한 장면을 연상시켜줄 것 같아요! 🏙️",
          "음악을 틀면 거리마다 다양한 음악 스타일로 채워진 듯한 환상을 느낄 수 있을 거에요!",
          '"하교/퇴근길" 선택! 지루한 길이 화려한 댄스 무대로 변신하는 기분을 느껴봐요!',
          "음악을 듣는 동안 거리가 나만의 음악 영화의 장면으로 변하는 것 같아요.",
          "곡마다 다른 장소의 이야기들이 펼쳐지는 듯한 환상적인 느낌!",
          "음악과 함께라면 하교/퇴근길이 마치 나만의 음악 비디오로 변하는 것 같아요.",
        ],
        idx: 8293,
      },
      {
        tag: "카페☕️",
        bg: "https://images.unsplash.com/photo-1565650839149-2c48a094196c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2066&q=80",
        ment: [
          "카페 안에서 음악이 내 속에 퍼져나가며 감각적인 즐거움을 선사해줄 거에요!",
          "음악을 듣는 동안 커피잔들이 리듬에 맞춰 춤을 추는 듯해요!",
          "마치 음악이 주문한 커피처럼 특별한 맛으로 내려와, 여운을 남겨줄 거에요! ",
          "음악을 듣는 동안 카페가 내 노래에 맞춰 살아 움직이는 듯한 장면을 상상해보세요!",
          "마치 커피콩들이 음악의 비트에 맞춰 뛰는 듯한 느낌을 느낄 수 있을 거에요!",
          "카페에서 음악을 틀고 맛있는 커피 한 잔과 함께 즐거운 음악의 여행을 떠나봐요!",
        ],
        idx: 147,
      },
      {
        tag: "산책🏃‍♀️",
        bg: "https://images.unsplash.com/photo-1684640683985-297bb996a424?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        ment: [
          '"산책" 선택! 발걸음마다 음악의 리듬에 어울리는 멋진 산책이 될 거에요!',
          "산책 중에 음악을 듣는다면, 나만의 힐링 여행을 떠나는 느낌을 받을 수 있을 거에요!",
          "음악을 틀면 산책로가 나와 함께 모험을 만들어줄 거에요!",
          "산책하는 동안 바람과 어울려 멋진 오케스트라를 연주하는 듯한 기분을!",
          "음악과 함께 자연과 함께 노래하며 걷는 듯한 기분을 느껴보세요.",
          "음악과 함께하는 산책 시간! 음악이 산책로의 가이드!",
        ],
        idx: 8003,
      },
      {
        tag: "운동⛹️",
        bg: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "내 운동 파트너가 음악의 비트와 함께 춤을 춰줄 거에요.",
          "운동 중에 음악을 듣는다면, 액션 영화의 주인공이 되어 몸과 마음을 성장시켜 줄 거에요!",
          "음악이 나만의 화려한 운동 퍼포먼스를 선보이는 듯한 기분이 들 거에요.",
          "음악을 듣는 동안 움직임 하나하나가 재미있는 모험으로 느껴질 거에요.",
          "운동 중에 음악을 들으면, 음악의 빠른 템포가 나를 영화 속 주인공으로 만들어 줘요. ",
          '"운동" 선택! 내 신나는 운동 친구가 운동을 더욱 즐겁게 만들어줄 거에요.',
        ],
        idx: 925,
      },
      {
        tag: "맑음🌞",
        bg: "https://images.unsplash.com/photo-1504753930079-4c0b71580d40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        ment: [
          "음악의 화음으로 하늘을 열어서, 맑은 멜로디로 가득찬 음악을 들어봐요.",
          "맑은 날씨처럼 음악도 내 안의 구름을 걷어내어 맑고 투명한 기분을 선사해줄 거에요.",
          "맑은 공기처럼 음악의 조화로운 음색이 마음을 청명한 상태로 만들어줄 거에요.",
          "맑은 날처럼 음악이 나만의 기억을 불러일으켜 살며시 미소를 지어줄 것 같아요.",
          "맑은 날처럼 음악이 내 마음을 맑게 청소해주는 듯한 느낌이 들 거에요.",
          "음악의 화음이 마치 내 안의 레인보우처럼 맑고 화사한 시간을 선사해줄 거에요.",
        ],
        idx: 776,
      },
      {
        tag: "구름☁️",
        bg: "https://images.unsplash.com/photo-1499346030926-9a72daac6c63?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        ment: [
          "구름처럼 가벼운 음악이 나를 둥실둥실 떠다니게 해요.",
          "음악의 음색이 구름을 따라 미끄러져 내려와, 나만의 하늘을 펼쳐줄 거에요.",
          "구름을 향해 뻗어가듯 음악의 소리가 나의 마음까지 퍼져나갈 거에요.",
          "구름 중에서도 가장 밝은 음악의 색깔이 나만의 하늘을 새롭게 그려줄 거에요.",
          "음악과 함께하는 구름 속 여행! 음악의 하모니가 내 안의 구름들을 노래해요.",
          "구름과 음악의 마법적인 만남이 내 마음을 사로잡을 거에요.",
        ],
        idx: 8000,
      },
      {
        tag: "비🌧️",
        bg: "https://images.unsplash.com/photo-1523772721666-22ad3c3b6f90?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
        ment: [
          "비 내리는 소리와 음악의 조화가 내 마음을 신비롭게 감싸줄 거에요.",
          "비의 울림이 나의 감정을 더욱 깊고 감미롭게 만들어줄 거에요.",
          "음악을 들으면 내 감정과 비의 슬픔이 서로 공감하는 듯한 기분이 들 거에요.",
          "음악이 내 마음의 비올 때와 같이 느껴져, 감정이 흐르듯이 어울릴 거에요.",
          "음악과 함께하는 비 속 여정! 음악과 비의 풍경이 내 마음을 여행시켜 줄 거에요.",
          "비와 음악의 조화가 내 안의 어둠을 밝혀줄 거에요.",
        ],
        idx: 784,
      },
      {
        tag: "눈❄️",
        bg: "https://cdn.iusm.co.kr/news/photo/201402/444938_136156_1721.jpg",
        ment: [
          "눈 내리는 날 내 마음도 음악과 눈의 아름다움으로 가득할 거에요.",
          "음악을 틀면 마치 음악의 선율이 눈송이처럼 내릴거에요.",
          "눈 내리는 날, 음악이 눈결과 어울려 신비로운 분위기를 만들어줄 것 같아요.",
          "음악이 내 마음의 눈송이처럼 눈의 신비로운 대화를 느낄 거에요.",
          "음악과 함께하는 눈 속 모험! 음악의 하모니가 내 마음을 사로잡을 거에요.",
          "피아노 소리와 눈의 조화로운 공연이 열리는 듯한 느낌을 받을 거에요.",
        ],
        idx: 779,
      },
      {
        tag: "봄🌸",
        bg: "https://images.unsplash.com/photo-1462275646964-a0e3386b89fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1528&q=80",
        ment: [
          "봄바람이 음악의 화음을 싣고 내 마음에 상쾌한 기운을 전해줄 거에요.",
          "봄의 향기와 음악의 선율이 내 마음을 한껏 활기차게 만들어요.",
          "봄의 새싹이 음악의 리듬에 맞춰 성장하듯 나의 마음을 찬란하게 물들일 거에요.",
          "음악이 봄의 따뜻한 햇살을 가득 담아내어, 화사한 봄날을 만들어줄 것 같아요.",
          "음악의 조화로운 음색이 나의 봄을 더욱 아름답게 만들어줄 거에요.",
          "음악과 함께하는 봄 속 여행! 음악과 봄의 풍경이 나의 마음을 빛낼 거에요.",
        ],
        idx: 783,
      },
      {
        tag: "여름🏖️",
        bg: "https://images.unsplash.com/photo-1603538966022-afcc0803652e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "음악과 함께라면 더운 여름에도 리듬이 내 마음을 시원하게 날려줄 거에요.",
          "여름 햇살과 음악의 선율이 내 마음을 밝게 비추어줘요.",
          "음악의 템포가 여름의 뜨거움을 더욱 풍성하게 느껴지게 해줘요.",
          "음악이 바닷가의 느낌을 담아내어, 나만의 해변 휴가를 선사해줄 거에요.",
          "여름날, 음악이 파도를 일으켜, 내 마음을 시원하게 휘저어줄 것 같아요.",
          "음악의 하모니가 여름바다의 파도를 노래하며, 나의 마음을 여행시켜 줄 거에요.",
        ],
        idx: 788,
      },
      {
        tag: "가을🍂",
        bg: "https://images.unsplash.com/photo-1501973801540-537f08ccae7b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1469&q=80",
        ment: [
          "선율이 가을 바람과 어우러져 내 마음을 차분하게 감싸줄 거에요.",
          "가을의 풍경과 음악의 화음이 내 마음을 따뜻하게 감싸줄 거에요.",
          "음악의 리듬이 가을의 색감과 어울려, 가을의 아름다움이 더욱 빛날 거에요.",
          "가을의 음악처럼, 나뭇잎들의 슬픈 떨림이 감정을 풍부하게 만들어줄 거에요.",
          "가을 향기, 내 마음의 회상을 불러일으켜, 추억이 나를 감동시킬 거에요.",
          "음악이 가을의 어느 순간을 멈추어 놓듯, 나를 여유롭게 만들어줄 거에요.",
        ],
        idx: 762,
      },
      {
        tag: "겨울☃️",
        bg: "https://images.unsplash.com/photo-1626374487693-2651ea4a233a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1167&q=80",
        ment: [
          "음악의 리듬이 겨울의 눈송이처럼 내 마음을 차갑게 식히고 따뜻하게 녹일 거에요.",
          "겨울의 서리와 음악의 멜로디가 내 마음을 차분하게 감싸줄 거에요.",
          "음악의 선율이 겨울의 고요함과 어울려, 겨울의 아름다움이 더욱 빛날 거에요.",
          "음악이 눈 내리는 날을 담아내어, 나만의 겨울 이야기를 만들어줄 거에요.",
          "겨울날, 음악의 리듬이 내 마음을 상큼하게 휘저어줄 것 같아요.",
          "음악과 함께하는 겨울 속 모험! 겨울 풍경이 나의 마음을 가득 채워줄 거에요.",
        ],
        idx: 768,
      },
    ],
  },
  {
    type: "기분",
    key: "feeling",
    question: [
      "만약 음악을 들으며 걷는다면, 현재 어떤 기분으로 거리를 걷고 계신가요?",
      "창 밖을 보세요 . 지금 어떤 기분이 드나요?",
      "오늘 하루를 기분으로 표현하자면 어떤 기분이신가요?",
      "당신의 음악적인 에너지를 커피 한 잔 만들어 마신다면 어떤 기분이 들 것 같나요?",
      "지금 당신의 뇌 속에서 가장 많은 부분을 차지하고 있는 것은 어떤 기분인가요?",
      "머릿속에 멜로디가 흥얼거리고 있어요. 그 멜로디로 인해 어떤 기분이 드나요?",
      "당신의 음악 감성을 한 마디로 표현한다면, 무엇을 떠올리시나요?",
      "당신의 기분을 시로 표현한다면, 그 시의 분위기와 느낌은 어떨까요?",
      "기분이 음악으로 이루어진 미술 작품이 있다면, 그 작품의 특징은 무엇일까요?",
      "당신의 기분이 떠오르는 시각 예술 작품이 있다면, 그 작품의 주요 요소는 무엇일까요?",
    ],
    none: {
      tag: "없어요🤔",
      bg: "asdf",
      ment: [
        "어떤 기분이든 음악이 당신을 위한 노래를 준비하고 있어요!",
        "기분 선택이 어려울 때, 음악이 당신의 내면을 읽어내어 어울리는 곡을 골라줄거에요.",
        "음악은 당신의 감정을 읽어내어 어떤 곡이 당신의 기분에 어울릴지 선택하고 있어요.",
        "기분을 선택하지 않아도, 음악이 당신의 감정을 표현하는 느낌을 받을 거에요.",
        "마음에 컬러풀한 페인트칠을 하며 음악과 함께 감정을 그려보아요.",
      ],
      idx: -1,
    },
    tagList: [
      {
        tag: "행복해요😊",
        bg: "https://images.unsplash.com/photo-1534361960057-19889db9621e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        ment: [
          "내 마음이 음악의 리듬에 맞춰 춤을 추며, 행복의 노래가 울려 퍼질 거에요.",
          "행복한 기분과 음악의 하모니가 내 마음을 부드럽게 감싸줄 거에요.",
          "음악의 선율이 내 행복한 감정을 음악적 언어로 번역해 줄 거에요.",
          "음악이 나의 행복한 기억을 재생시켜 더욱 생생하게 만들어줄 거에요.",
          "음악의 멜로디가 내 안의 행복을 더욱 다채롭게 만들어줄 거에요.",
          "행복한 날, 음악의 음색이 나의 행복을 더욱 환하게 빛낼 것 같아요. ",
        ],
        idx: 5330,
      },
      {
        tag: "불안해요😞",
        bg: "https://images.unsplash.com/photo-1523178089986-5af0e97effb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "음악과 함께라면 음악의 음색이 내 안의 불안을 서서히 진정시켜줄 것 같아요.",
          "불안한 마음과 음악의 소리가 합쳐지면, 내 안의 불안을 해소시켜 줄 거에요.",
          "음악의 선율이 내 안의 불안을 녹여내어, 기분을 조용히 해소해줄 거에요.",
          "음악이 내 안의 감정을 공감하듯이, 내 안의 불안을 달래줄 거에요.",
          "불안한 날, 음악의 음색이 내 안의 불안을 안정시켜 줄 것 같아요.",
          "음악이 내 안의 불안을 따뜻하게 감싸주어, 불안함을 서서히 가라앉힐 거에요.",
        ],
        idx: 5709,
      },
      {
        tag: "신나요🤩",
        bg: "https://images.unsplash.com/photo-1509909756405-be0199881695?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "음악의 템포가 내 마음을 신나게 달굴 거에요, 내 안의 파티가 시작되요!",
          "신나는 음악의 선율이 신나는 에너지로 가득 채워줄 거에요.",
          "음악의 비트가 내 몸을 두드리며, 내 마음이 흥분되는 느낌이 들 거에요!",
          "신나는 순간처럼, 음악이 내 안의 신나는 무도회를 연출해줄 거에요.",
          '"신나요" 선택! 음악을 듣는 동안 신나는 행복함이 가득할 거에요!',
          "신나는 날, 음악의 리듬이 내 안의 흥분을 자극해줄 것 같아요.",
        ],
        idx: 5710,
      },
      {
        tag: "편안해요😌",
        bg: "https://images.unsplash.com/photo-1517315003714-a071486bd9ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80",
        ment: [
          "편안한 음악의 선율이 내 마음에 부드러운 어묵을 곁들여줘요.",
          "음악을 틀면 리듬이 따스한 차 한잔과 같은 기분으로 느껴질 거에요.",
          "음악의 리듬이 마치 오래된 친구와 함께하는 휴식같은 느낌이 들 거에요.",
          "편안한 날, 음악의 음색이 내 안의 편안함을 더욱 높여줄 것 같아요.",
          "음악과 함께하는 편안한 여정! 풍경이 내 안의 휴식을 더욱 깊게 만들어줄 거에요.",
          "음악과 나의 여유가 어우러져 마음이 편안해질 거에요.",
        ],
        idx: 5711,
      },
      {
        tag: "졸려요😴",
        bg: "https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1460&q=80",
        ment: [
          "음악의 리듬이 내 안의 졸림을 서서히 떨쳐낼 거에요. 깨어나세요!",
          "졸린 눈을 비벼보세요! 음악이 시원한 물처럼 머리를 씻어줄 거에요. ",
          "음악이 내 마음을 살짝 놀려주듯이, 졸린 기운을 후려쳐줄 거에요!",
          "졸린 눈을 한 번 깜박하세요! 음악의 빛나는 리듬이 졸림을 밀어내줄 거예요.",
          "졸린 느낌을 손가락으로 털어내보세요! 음악이 졸림을 강력하게 눌러놓을 거에요.",
          "음악이 내 마음의 알람 벨소리처럼, 졸린 감정을 깨워줄 거에요.!",
        ],
        idx: 5326,
      },
      {
        tag: "설레요🥰",
        bg: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "음악과 함께라면 화음이 내 마음을 춤추게 만들어줄 거에요.",
          "설레는 마음과 음악의 소리가 마치 첫 데이트와 같이 달콤하게 채워줄 거에요.",
          "음악의 리듬이 설레는 마음을 더욱 빛나게 해줘, 새로운 사랑이 시작된 듯한 느낌!",
          "음악이 설레임을 노래하며, 내 안의 감정을 더욱 깊게 만들어줄 거에요.",
          "음악의 음색이 내 안의 설레는 감정을 더욱 높여줄 거에요.",
          "음악과 함께하는 설레는 여정! 내 안의 설레는 기분을 더욱 돋보이게 해줄 거에요.",
        ],
        idx: 5712,
      },
      {
        tag: "그리워요🥺",
        bg: "https://images.unsplash.com/photo-1484347500940-3a373367eb8f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80",
        ment: [
          "그리운 마음과 음악의 울림이 마치 오랜 친구를 만나는 느낌이네요.",
          "음악의 선율이 오랜만에 만난 가족과 함께하는 따뜻한 순간을 떠올릴 거에요.",
          "음악이 내 안의 그리움을 노래하며, 향수를 더욱 깊게 만들어줄 거에요.",
          "음악이 내 마음의 터널을 통과하며, 내 안의 그리움을 따뜻하게 바꿔줄 거에요.",
          "음악의 하모니가 내 그리움을 노래하며, 내 안의 향수를 더욱 감미롭게 만들어줄 거에요.",
          "음악과 나의 그리움이 어우러져 따뜻한 감정이 마음 가득할 거에요.",
        ],
        idx: 5713,
      },
      {
        tag: "슬퍼요😭",
        bg: "https://images.unsplash.com/photo-1470432581262-e7880e8fe79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1472&q=80",
        ment: [
          "음악의 울림이 감정을 풀어내어, 슬픔을 나누는 친구를 만난 듯한 느낌이에요.",
          "음악을 틀면 비가 내리는 날의 울적한 기분을 나누는 것처럼 느낄 거에요.",
          "슬픈 순간의 음악적 풍경이 내 안의 감정을 더욱 깊게 만들어줄 거에요.",
          "슬픈 날, 내 마음의 슬픔을 감싸줄 듯이, 따뜻하게 만들어줄 거에요.",
          "음악적 풍경이 내 안의 감정을 더욱 부드럽게 만들어줄 거에요.",
          "음악과 나의 슬픔이 어우러져 마음의 아픔을 조금이나마 덜어줄 거에요.",
        ],
        idx: 5324,
      },
      {
        tag: "싱숭생숭😶",
        bg: "https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FUWTaS%2FbtqQNqa2Zrw%2Fa1GhcpfBrJxfQ7gKrlTB20%2Fimg.jpg",
        ment: [
          "신비한 음악의 세계로의 초대장을 받은 것 같지 않나요? 이제 모험을 시작해보세요!",
          "음악을 새로운 감각으로 경험하며 감각적인 퍼즐 조각을 맞추는 듯한 느낌이에요.",
          "음악의 미묘한 감정을 탐구하며 세세한 표현을 읽는 해석가가 되봐요!",
          "음악의 조각들을 모아 예술적인 콜라주를 만드는 듯한 느낌을 받을 수 있어요.",
          "음악의 섬세한 표현을 더 깊이 느껴보며 퍼즐 조각을 맞추는 도전을 하게 될 것 같아요.",
          "음악의 다양한 색상과 뉘앙스를 탐구하며 미묘한 변화를 읽는 시각이 확장될 수 있어요.",
        ],
        idx: 222,
      },
      {
        tag: "화나요🤬",
        bg: "https://images.unsplash.com/photo-1489189642444-0709966aec44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
        ment: [
          "음악의 울림이 번개처럼 내 안의 감정을 강력하게 흔들어 줘요.",
          "음악의 선율이 내 화난 마음을 더욱 공감하게 만들어요",
          "내 안의 화난 감정을 노래하여, 내 분노를 감각적으로 만들어줄 거에요.",
          "음악의 음색이 내 안의 감정을 더욱 부각시켜줄 거에요.",
          "음악의 하모니가 내 분노를 노래하며, 감정을 더욱 강렬하게 만들어줄 거에요.",
          "음악과 나의 화난 감정이 어우러져 분노를 해소하는 느낌을 받을 거에요.",
        ],
        idx: 5322,
      },
    ],
  },
  {
    type: "스타일",
    key: "style",
    question: [
      "당신의 상황을 햄버거로 비유한다면, 어떤 스타일이 그 믹스와 어울릴지 상상해보세요! 🍔",
      "당신의 마음을 음악으로 표현한다면, 어떤 느낌일까요?",
      "시간을 거슬러 돌아가서, 어릴 적 가장 좋아했던 노래 한 곡을 떠올려보세요. 그 노래는 여전히 당신에게 어떤 느낌을 줄까요",
      "당신의 인생을 백그라운드 뮤직으로 설정한다면, 그 음악은 어떤 스타일일까요?",
      "머릿속에 있는 음악을 테마 곡으로 만든다면, 그 음악의 분위기와 리듬을 한 단어로 표현해보세요.",
      "당신의 음악과 관련된 비밀이 있다면 말씀해보세요. 그런 비밀스러운 느낌을 담은 노래를 찾아드릴게요!",
      "당신의 취향의 음악이 흘러나오는 빈티지 쇼핑몰에서 어떤 느낌을 받으실 것 같나요?",
      "당신의 현재 기분과 관련된 노래 한 곡을 생각해보세요. 그리고 그 노래는 무슨 이유로 어울리는지 알려주세요!",
      "지금 하고 있는 일에 어떤 느낌의 음악이 잘 어울릴 것 같아요?",
      "당신의 내면을 춤으로 나타낸다면, 어떤 느낌으로 춤을 추게 될 것 같나요?",
    ],
    none: {
      tag: "없어요🤔",
      bg: "asdf",
      ment: [
        "스타일을 선택하지 않아도, 어울리는 음악을 듣는 느낌을 받을 수 있을 거에요.",
        "어떤 스타일이든, 멋진 음악 스타일을 제안하고 있는 느낌을 줄 거에요.",
        "어떤 스타일이든, 음악 스타일을 디자인하고 있는 듯한 느낌을 줄 거에요.",
        "음악의 팔레트에서 다양한 색감의 음악을 색칠하는 즐거움을 느낄 수 있을 거에요.",
        "어떤 음악 스타일이든, 다양한 장르의 음악을 제안하며 멋진 음악 탐험을 도와줄 거에요.",
      ],
      idx: -1,
    },
    tagList: [
      {
        tag: "그루브한🚶🏿‍♂️",
        bg: "https://images.unsplash.com/photo-1663271298157-089bc7c3cbcf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1478&q=80",
        ment: [
          "음악의 비트가 내 몸을 자연스럽게 따라 움직이게 만들어요.",
          "그루브한 음악과 함께라면 내 마음을 흔들어 춤을 추게 만들어줄 거에요.",
          "음악의 그루브가 내 안의 음악적 에너지를 폭발시키는 느낌을 받을 거에요.",
          '"그루브" 모드 ON! 내 안의 그루브가 음악과 어우러져 춤을 추듯한 기분을!',
          "음악이 내 안의 그루브를 노래하며, 내 몸의 리듬을 더욱 깊게 만들어줄 거에요.",
          "음악의 그루브가 내 몸을 미끄러지듯 감싸주어, 춤을 추는 듯한 느낌이 들 거에요.",
        ],
        idx: 298,
      },
      {
        tag: "감성적인🔮",
        bg: "https://images.unsplash.com/photo-1555704318-0cff1b92c833?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "멜로디가 내 감정을 애절하게 표현하듯, 내 마음을 따뜻하게 감싸줄 거에요.",
          "감성적인 음악과 함께라면 음악의 하모니가 내 마음을 안정시켜줄 거에요.",
          "음악의 선율이 내 안의 감성을 노래하는 듯한 기분을 받을 거에요.",
          "감성적인 음악의 멜로디가 내 감성을 더욱 감미롭게 만들어줄 거에요.",
          "음악의 감성이 내 안의 감정을 단아하게 표현하는 듯한 느낌을 받을 거에요.",
          "감성적인 순간, 음악의 음색이 내 안의 감정을 더욱 부각시켜줄 거에요.",
        ],
        idx: 284,
      },
      {
        tag: "어쿠스틱한🪕",
        bg: "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "어쿠스틱한 소리가 내 마음을 풍부하게 만들어줄 거에요.",
          "음악을 틀면 어쿠스틱한 소리가 내 감정을 더욱 깊게 만들어 줄거에요.",
          "음악이 내 안의 어쿠스틱한 감정을 노래하며, 내 마음을 더욱 풍부하게 해줄 거에요.",
          '"어쿠스틱한" 선택! 음악을 듣는 동안 내 안의 감정을 부드럽게 해소시켜줘요.',
          "어쿠스틱한 날, 어쿠스틱한 음색이 내 안의 감정을 더욱 깊게 만들어줄 거에요.",
          "어쿠스틱한 소리가 마치 내 마음의 소리를 노래하여 내 마음을 더욱 따뜻하게 할 거에요.",
        ],
        idx: 496,
      },
      {
        tag: "몽환적인🌈",
        bg: "https://images.unsplash.com/photo-1543180896-d30121f77615?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1454&q=80",
        ment: [
          "몽환적인 음악과 함께라면 하모니가 내 마음을 신비롭게 만들어줄 거에요.",
          "음악의 선율이 음악 속으로 빠져든 듯한 신비로운 느낌을 받을 거에요.",
          "몽환적인 음악의 울림처럼, 음악이 내 안의 상상을 노래해요.",
          "몽환적인 순간, 음악이 내 안의 감정을 더욱 심화시켜줄 거에요.",
          "음악과 함께하는 몽환적인 여정! 음악의 선율이 마치 내 상상을 노래해요.",
          "음악과 나의 상상세계가 하나로 어우러져 신비로운 느낌을 받을 거에요.",
        ],
        idx: 375,
      },
      {
        tag: "강렬한🚨",
        bg: "https://images.unsplash.com/photo-1597694491593-5028b171050d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
        ment: [
          "음악의 파워가 마치 나를 강력하게 감싸듯, 활기차게 만들어줄 거에요.",
          "강렬한 음악과 함께라면 음악의 인텐시브한 분위기가 내 마음을 자극할 거에요.",
          "음악을 틀면 내 안의 열정이 음악과 어우러지는 듯한 느낌을 받을 거에요.",
          '"강렬한" 모드 ON! 음악의 강렬한 에너지가 내 마음을 휩쓸어요.',
          "음악이 내 안의 에너지를 노래하며, 내 마음을 더욱 강렬하게 만들어줄 거에요.",
          "음악의 강렬한 에너지가 내 안의 열정을 해방시켜주는 느낌을 받을 거에요.",
        ],
        idx: 943,
      },
      {
        tag: "잔잔한🌅",
        bg: "https://images.unsplash.com/photo-1496293455970-f8581aae0e3b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1113&q=80",
        ment: [
          "잔잔한 음악과 함께라면 음악의 조용한 분위기가 내 마음을 휴식시켜줄 거에요.",
          "음악의 울림이 나만의 감성적인 여정에 빠져든 느낌을 받을 거에요.",
          "잔잔한 음악의 울림이 내 마음을 더욱 깊게 만들어줄 거에요.",
          "잔잔한 순간, 음악이 나만의 작은 세상을 그려줄 거에요.",
          "음악의 선율이 내 마음을 더욱 평온하게 만들어줄 거에요.",
          "음악과 나의 휴식의 순간이 하나로 어우러져 편안한 느낌을 받을 거에요.",
        ],
        idx: 555,
      },
      {
        tag: "감각적인👀",
        bg: "https://images.unsplash.com/photo-1548123378-bde4eca81d2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "감각적인 음악의 색다른 분위기가 내 마음을 감성적으로 만들어줄 거에요.",
          "음악의 향기가 내 몸을 감각적인 여정에 빠져든 느낌을 받을 거에요.",
          "감각적인 음악의 향기가 내 마음을 더욱 감각적으로 만들어줄 거에요.",
          "음악의 음색이 내 안의 감정을 더욱 부각시켜줄 거에요.",
          "음악의 향기가 내 마음을 더욱 감각적으로 만들어줄 거에요.",
          "음악과 나의 감각적인 순간이 하나로 어우러져 예술적인 느낌을 받을 거에요.",
        ],
        idx: 277,
      },
      {
        tag: "소울풀한💫",
        bg: "https://images.unsplash.com/photo-1554254950-3667414ee579?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "소울풀한 멜로디가 내 마음을 따뜻하게 만들어줄 거에요.",
          "소울풀한 음악과 함께라면 음악의 감미로운 분위기가 내 마음을 감동시켜줄 거에요.",
          "음악을 틀면 마치 나만의 소울풀한 여정에 빠져든 느낌을 받을 거에요.",
          '"소울풀한" 모드 ON! 내 안의 감정을 음악에게 맡기는 느낌을 느낄 거에요.',
          "소울풀한 음악이 내 마음을 더욱 따뜻하게 만들어줄 거에요.",
          '"소울풀한" 선택! 음악의 소울풀한 감동이 내 마음을 마사지해요.',
        ],
        idx: 456,
      },
    ],
  },
  {
    type: "장르",
    key: "genre",
    question: [
      "당신의 상황이 하늘의 별빛으로 비춰진다면, 어떤 장르가 그리운 밤을 더 아름답게 만들까요? 🌌",
      "가상의 무대에서 노래를 부를 수 있다면, 어떤 장르를 선곡하실 건가요? 🎤🤩",
      "마지막의 들은 노랜 어떤 장르인가요?",
      "지금 노래를 흥얼거린 다면 그 노래는 어떤 장르인가요?",
      "마음 속에 작은 비밀이 있다면, 그 비밀을 풀어내는 장르라는 이름의 작은 열쇠는 어떤 것인가요?",
      "마음 속 꿈나무가 무슨 음악을 듣고 뛰어오를지 상상해보세요. 그 음악을 함께 찾아드릴게요!",
      "만약 음악이 당신의 뇌파와 동기화 된다면, 지금은 어떤 장르의 리듬일까요?",
      "당신의 인생 스토리를 노래로 만든다면, 현재 장면은 어떤 장르의 노래로 표현되어야 할까요?",
      "당신의 귀를 사로잡는 노래 한 곡을 들었을 때, 그 노래는 어떤 장르인가요?",
      "요즘 일상에서 어떤 장르의 음악을 틀어 놓고 싶으신가요?",
    ],
    none: {
      tag: "없어요🤔",
      bg: "asdf",
      ment: [
        "장르 선택을 고민 중이시군요! 음악의 모험가처럼 새로운 발견을 할 준비가 되셨나요?",
        "어떤 음악을 선택하든, 당신의 취향을 열어주는 마법의 문이 열린 것처럼 다가올 거에요.",
        "장르 선택을 하지 않아도, 음악은 함께 음악의 세계를 탐험할 준비를 하고 있어요.",
        "당신의 선택을 위해 다양한 음악 장르의 열쇠를 손에 쥐고 있어요.",
        "장르를 선택하지 않으셔도, 다양한 커스텀 메뉴를 기대할 수 있어요.",
      ],
      idx: -1,
    },
    tagList: [
      {
        tag: "POP💃",
        bg: "https://images.unsplash.com/photo-1476382929176-f7b329008e17?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
        ment: [
          "POP 음악의 화려한 색채가 내 마음을 신나게 만들어줄 거에요.",
          "POP 음악과 함께라면 음악의 상큼한 분위기가 내 마음을 활력 있게 만들어줄 거에요.",
          "음악의 POP한 매력이 내 안의 신나는 에너지와 어우러지는 느낌을 받을 거에요.",
          '"POP" 모드 ON! 내가 음악의 비트에 맞춰 움직이는 느낌을 느낄 거에요.',
          "POP 음악의 화려함처럼 음악이 내 안의 감각을 노래 할 거에요.",
          '"POP" 선택! 음악의 POP한 리듬이 내 안의 신나는 모습을 노래하는 느낌을 받을 거에요.',
        ],
        idx: 748,
      },
      {
        tag: "R&B/Soul🎺",
        bg: "https://images.unsplash.com/photo-1486334803289-1623f249dd1e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1227&q=80",
        ment: [
          "R&amp;B/Soul 선택! R&amp;B/Soul한 멜로디가 내 마음을 깊이 만들어줄 거에요.",
          "R&amp;B/Soul 음악이 내 몸을 끌어당겨 소울풀한 감정이 펼쳐지는 느낌을 받을 거에요.",
          "R&amp;B/Soul 모드 ON! 내가 음악에게 말하는 듯한 느낌을 느낄 거에요.",
          "R&amp;B/Soul 음악의 감미로움이 내 마음을 더욱 깊게 만들어줄 거에요.",
          "R&amp;B/Soul 음악의 감동이 내 마음을 여운에 싸주는 느낌을 받을 거에요.",
          "R&amp;B/Soul 음악의 감미로운 내 마음을 더욱 깊게 만들어줄 거에요.",
        ],
        idx: 721,
      },
      {
        tag: "댄스🕺",
        bg: "https://images.unsplash.com/photo-1621976498727-9e5d56476276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
        ment: [
          '"댄스" 선택! 음악의 리듬이 나의 몸을 흔들어 내 마음을 환희롭게 만들어줄 거에요.',
          "댄스 음악과 함께라면 내 안의 리듬이 음악과 어우러질 거에요.",
          "댄스 노래를 듣고 에너지가 내 몸을 가득 채워지는 느낌을 받을 거에요.",
          '"댄스" 모드 ON! 음악의 리듬이 내 몸을 춤추게 만들어요.',
          "댄스 음악의 열정처럼 음악이 내 마음을 더욱 들뜨게 만들어줄 거에요.",
          "음악의 댄스 리듬이 내 마음을 활력 있게 만들어요.",
        ],
        idx: 694,
      },
      {
        tag: "랩/힙합🎧",
        bg: "https://images.unsplash.com/photo-1572648586565-8b332ccd46e4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
        ment: [
          '"랩/힙합" 선택! 힙합의 멋진 비트가 내 마음을 흥분시켜줄 거에요.',
          "음악의 힘을 내 몸에 전달해주어 내 안의 스트릿 느낌이 느껴질 거에요.",
          '"랩/힙합" 모드 ON! 내가 음악과 함께 랩 배틀을 하는 듯한 느낌을 느낄 거에요.',
          "힙합의 화끈한 분위기가 내 마음을 더욱 힙하게 만들어줄 거에요.",
          "힙합의 힘이 내 몸을 감싸 내가 음악의 리듬과 어우러지는 느낌을 받을 거에요.",
          "힙한 스타일이 내 몸을 흔들어 음악과 나의 순간이 하나로 어우러져요.",
        ],
        idx: 763,
      },
      {
        tag: "록/메탈🎸",
        bg: "https://images.unsplash.com/photo-1581742009630-afd6768aa98e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
        ment: [
          '"록/메탈" 선택! 강렬한 기타 사운드가 내 마음을 불태워줄 거에요.',
          "록한 음악과 함께라면 내 안의 투지가 음악과 어우러져요.",
          "음악을 틀면 내 안의 소울이 메탈과 하나로 어우러지는 느낌을 받을 거에요.",
          '"록/메탈" 모드 ON! 음악의 강렬한 사운드가 내 몸을 뒤틀어요.',
          '"록/메탈" 음악의 강렬한 스타일이 내 마음을 더욱 들뜨게 만들어줄 거에요.',
          "음악의 강렬한 사운드가 내 몸을 불태워, 내 안의 열정이 어우러지는 느낌을 받을 거에요.",
        ],
        idx: 2589,
      },
      {
        tag: "발라드🌫️",
        bg: "https://mblogthumb-phinf.pstatic.net/20161006_267/enjoyrun_1475748475612X5G8W_JPEG/selca1.jpg?type=w800",
        ment: [
          "발라드의 감미로운 분위기가 내 마음을 따스하게 만들어줄 거에요.",
          "발라드의 감성적인 느낌이 내 마음을 풍요롭게 만들어줄 거에요.",
          "발라드의 음악을 틀면 내 안의 감성을 음악과 함께 나누는 느낌을 받을 거에요.",
          "발라드의 풍부한 감성이 내 마음을 더욱 따스하게 만들어줄 거에요.",
          "음악의 감미로운 분위기가 내 마음을 따뜻하게 만들어줄 거에요.",
          "발라드의 감성적인 분위기가 내 마음을 더욱 풍성하게 만들어줄 거에요.",
        ],
        idx: 681,
      },
      // {
      //   tag: 'EDM🔊',
      //   bg: 'https://images.unsplash.com/photo-1517814761483-6769dab4e9c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
      //   ment: [
      //     '"EDM" 선택! EDM의 화려한 사운드가 내 마음을 파티 모드로 전환시켜줄 거에요.',
      //     'EDM 음악과 함께라면 내 안의 미친 듯한 리듬이 마음을 춤추게 만들어줄 거에요.',
      //     '음악을 틀면 전자적인 사운드가 내 몸을 감싸 내 안의 파티가 시작되요!',
      //     'EDM의 다채로운 사운드가 내 마음을 더욱 활기차게 만들어줄 거에요.',
      //     '파티 중의 음악이 전자적인 분위기가 내 몸을 활기차게 만들어줄 거에요.',
      //     '전자적인 사운드가 마치 내 안의 에너지를 노래하여 내 마음을 들뜨게 만들어줄 거에요.',
      //   ],
      //   idx: 725,
      // },
      {
        tag: "성인가요/트로트🎙️",
        bg: "https://images.unsplash.com/photo-1531971843716-2b9c25dbdece?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          "마치 내 안의 향수 같은 음악이 나를 과거로 데려가 내 마음을 어루만져줄 거에요.",
          "음악을 틀면 내 안의 추억을 노래하며 시작되는 듯한 느낌을 받을 거에요.",
          "옛날 노래가 내 몸을 감싸 과거와 음악이 어우러져요.",
          "감성적인 순간, 성인가요/트로트가 내 마음을 따스하게 만들어줄 거에요.",
          "음악의 감미로운 멜로디가 마치 내 안의 추억을 노래해요.",
          "옛날 노래가 내 몸을 감싸 하나로 어우러져 따스한 느낌을 받을 거에요.",
        ],
        idx: 714,
      },
      {
        tag: "인디음악🎼",
        bg: "https://images.unsplash.com/photo-1548277971-7fd24a60ff68?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          '"인디음악" 선택! 인디음악의 독특한 사운드가 내 마음을 아름답게 만들어줄 거에요.',
          "인디음악과 함께 내 안의 자유로운 영혼이 다채로운 세계로 나아가는 느낌을 받을 거에요.",
          "마치 내 안의 아티스트가 음악을 펼치는 순간을 느끼는 듯한 느낌을 받을 거에요.",
          "인디음악의 다양한 스타일이 내 마음을 더욱 풍요롭게 만들어줄 거에요.",
          "감성적인 순간, 인디음악의 독특한 분위기가 내 마음을 따뜻하게 만들어줄 거에요.",
          "음악과 함께 인디! 인디음악의 독특한 분위기가 내 마음을 더욱 풍성하게 만들어줄 거에요.",
        ],
        idx: 2660,
      },
      {
        tag: "재즈🎷",
        bg: "https://images.unsplash.com/photo-1548457701-c6a5aa364f49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1025&q=80",
        ment: [
          "음악의 스윙과 멜로디가 내 안의 멋진 재즈 클럽으로 변해요.",
          "재즈 음악과 함께라면 마치 리듬이 멋진 재즈 세계로 빠져들게 만들어줄 거에요.",
          "음악의 자유로운 리듬이 내 안의 재즈 마스터가 음악을 연주하는 듯한 느낌을 받을 거에요.",
          "재즈의 소리가 내 마음을 더욱 풍요롭게 만들어줄 거에요.",
          "감성적인 순간, 재즈의 멋진 분위기가 내 마음을 따뜻하게 만들어줄 거에요.",
          "음악과 멋진 재즈 여행! 재즈의 멋진 세계로 빠져들게 만들어줄게요.",
        ],
        idx: 731,
      },
      {
        tag: "클래식🎻",
        bg: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
        ment: [
          '"클래식" 선택! 시간을 건너 뛰어 영웅적인 서사가 내 앞에서 펼쳐져요.',
          "클래식 음악과 함께 내 안의 감정을 앙상블로 연주해요.",
          "음악의 고요한 울림이 내 안의 작곡가가 음악을 작곡하는 듯한 느낌을 줄 거에요.",
          "클래식 음악의 감미로운 선율과 함께 내 마음을 풍요롭게 만들어줄게요.",
          "클래식의 고요하고 아름다운 세계가 내 마음을 따뜻하게 만들어줄 거에요.",
          "나의 클래식한 순간이 하나로 어우러져 아름다운 느낌을 받을 거에요.",
        ],
        idx: 740,
      },
      {
        tag: "아이돌💖",
        bg: "https://images.unsplash.com/photo-1542833807-ad5af0977050?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1936&q=80",
        ment: [
          "아이돌들의 화려한 무대를 상상하며 팬미팅을 하는 느낌을 받아보세요.",
          '"아이돌" 음악으로, 아이돌들의 열정을 직접 만나는 것 같은 경험을 할 수 있을 거에요.',
          "음악의 리듬과 함께 아이돌들의 매력 넘치는 무대가 펼쳐지는 느낌을 받아보세요.",
          "음악의 비트에 맞춰 아이돌들의 파워풀한 무대를 상상하는 느낌을 받게 될 것 같아요.",
          "아이돌들의 화려한 무대와 함성 속으로 빠져들어 즐거운 음악 여행을 떠나보세요.",
          "아이돌들의 팬이 된 것처럼 음악의 매력과 함께 흥미로운 시간을 보낼 수 있을 거에요.",
        ],
        idx: 668,
      },
    ],
  },
];
